// eslint-disable-next-line import/prefer-default-export
export enum NewsfeedEnum {
    Sampled = 'sampled-newsfeed',
    New = 'new-newsfeed',
    User = 'user-newsfeed',
    Both = 'both-newsfeed',
    None = 'no-newsfeed',
}
